var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 16L12 23.9999V8L24 16ZM16 0.00299072C7.17529 0.00299072 0.00297546 7.1753 0.00297546 16C0.00297546 24.8247 7.17529 31.997 16 31.997C24.8247 31.997 31.997 24.8247 31.997 16C31.997 7.1753 24.8247 0.00299072 16 0.00299072ZM16 1.99704C23.7438 1.99704 30.003 8.2562 30.003 16C30.003 23.7438 23.7438 30.0029 16 30.0029C8.25617 30.0029 1.99703 23.7438 1.99703 16C1.99703 8.2562 8.25617 1.99704 16 1.99704Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.9acff8159525c451788707e3fe585623.svg";
export { ForwardRef as ReactComponent };